import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import map from 'lodash/map';
import omit from 'lodash/omit';
import pick from 'lodash/pick';
import keyBy from 'lodash/keyBy';

// import { Link } from 'react-router-dom';
import {
  Modal
} from 'reactstrap';
import ModalHeader from '../reactstrap/ModalHeader';


import { addLinkSuccess, loadProjectSuccess } from '../../actions';

import LinkForm from './cloneForm';
import { Link, currentProject as setCurrentProject } from '../../api';


const mapStateToProps = state => ({currentProject: state.currentProject});

const matchDispatchToProps = dispatch => {
  return bindActionCreators({ addLinkSuccess, loadProjectSuccess }, dispatch)
};


const modalPropKeys = Object.keys(Modal.propTypes);

class CloneLinkModal extends Component {
  
  onSuccess(res) {
    const { addLinkSuccess, toggle, onSuccess, currentProject, loadProjectSuccess } = this.props; 
    
    if (res && res.project_id && res.project_id !== currentProject.id ) {
      setCurrentProject(res.project_id).then((project) =>{
        loadProjectSuccess(project);
        addLinkSuccess(res);
      })
    }
    else
      addLinkSuccess(res);
    
    if ( onSuccess && typeof onSuccess === 'function')
      onSuccess(res)
    
    toggle();
  }
  
  sublinksToSettings (list, sublinks){
    return map(list, (l) => {return {...omit(l, ['id']), ...((sublinks[l.id] && pick(sublinks[l.id], ['url', 'title', 'type'])) || {}) }})
  }
  
  prepareInitialValues(link) {
    const {settings, sublinks} = link
    const sublinksById = sublinks && keyBy(sublinks, 'id')
    
    return {...pick(link,['url', 'project_id', 'meta']),
      settings: (link.type === 'biolink' ||  link.type === 'smartpage') ? {...settings, 
        messengers: this.sublinksToSettings(settings.messengers, sublinksById),
        social_links: this.sublinksToSettings(settings.social_links, sublinksById),
        buttons: this.sublinksToSettings(settings.buttons, sublinksById),
        blocks: this.sublinksToSettings(settings.blocks, sublinksById)
      } : settings
    }
  }
  
  render() {
    const { toggle, link, ...otherProps } = this.props;
    const modalProps = pick(otherProps, modalPropKeys);
    const initialValues = this.prepareInitialValues(link);
    
    return (
      <Modal {...modalProps} centered={true}>
        <ModalHeader toggle={toggle}>Duplicate link</ModalHeader>
        <LinkForm modalWrappers={true} onSubmit={Link.create} initialValues={initialValues} onSuccess={this.onSuccess.bind(this)} resetOnSuccess={true} />
      </Modal>
    );
  }
  
}

export default connect(mapStateToProps, matchDispatchToProps)(CloneLinkModal);


// WEBPACK FOOTER //
// ./src/components/Links/cloneModal.js